import ServiceProfileRestrictions from './ServiceProfileRestrictions';
export default ServiceProfileRestrictions;
